import { render, staticRenderFns } from "./UserRegistration.vue?vue&type=template&id=a2fa2a54&"
import script from "./UserRegistration.vue?vue&type=script&lang=ts&"
export * from "./UserRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./UserRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports